import { useEffect, useMemo, useState } from "react";
import Bell01Icon from "@untitled-ui/icons-react/build/esm/Bell01";
import { Badge, IconButton, SvgIcon, Tooltip } from "@mui/material";
import { usePopover } from "../../hookes/use-popover";
import NotificationsDataPopover from "./notification-popover";
import {
  getNotifications,
  editNotification,
} from "../../state-management/actions/notification-actions";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../../state-management/selectors";

const useNotifications = () => {
  const dispatch = useDispatch();
  const { currentUserData } = useSelector(selectGlobalState);
  const [notificationData, setNotificationData] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getNotifications()(dispatch);
        if (response.data) {
          const data = response.data.filter((item: any) =>
            item.visited.find(
              (it: any) =>
                it.user_id === currentUserData._id && it.show === true
            )
          );
          setNotificationData(data);
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    fetchData();
  }, [dispatch, currentUserData]);

  const unread = useMemo(() => {
    return notificationData.reduce(
      (acc: any, notif: any) =>
        acc + (notif.visited?.find((item: any) => item.read === true) ? 0 : 1),
      0
    );
  }, [notificationData]);

  const handleRemoveOne = async (notificationId: any) => {
    setNotificationData((prevState) =>
      prevState.filter((notification) => notification._id !== notificationId)
    );

    try {
      const editData = notificationData.find(
        (item) => item._id === notificationId
      );
      if (!editData) return;
      const updatedData = {
        visited: editData.visited.map((it: any) =>
          it.user_id === currentUserData._id ? { ...it, show: false } : it
        ),
      };
      await editNotification(notificationId, updatedData)(dispatch);
    } catch (error) {
      console.error("Error removing notification:", error);
    }
  };

  const handleMarkAllAsRead = async () => {
    setNotificationData([]);
    try {
      await Promise.all(
        notificationData.map((notification: any) => {
          const updateData = {
            visited: notification.visited.map((it: any) =>
              it.user_id === currentUserData._id ? { ...it, show: false } : it
            ),
          };
          return editNotification(notification._id, updateData)(dispatch);
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
  return {
    handleMarkAllAsRead,
    handleRemoveOne,
    notificationData,
    unread,
  };
};

export const NotificationsButton = () => {
  const popover = usePopover();
  const { handleRemoveOne, handleMarkAllAsRead, notificationData, unread } =
    useNotifications();

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton ref={popover.anchorRef} onClick={popover.handleOpen}>
          <Badge color="error" badgeContent={unread}>
            <SvgIcon>
              <Bell01Icon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <NotificationsDataPopover
        anchorEl={popover.anchorRef.current}
        notifications={notificationData}
        onClose={popover.handleClose}
        onMarkAllAsRead={handleMarkAllAsRead}
        onRemoveOne={handleRemoveOne}
        open={popover.open}
      />
    </>
  );
};
